import UserDetailConvArchive from 'components/UserDetailsConvArchive';
import styles from './styles.module.scss';
import { AccessOverlay } from 'components';

const ALLOWED_TYPES = [1, 2, 3, 6, 7, 8, 10, 11]; // آزمایشی + تجاری + پریمیوم + پایه + پریمیوم پلاس + وی آی پی

function UserDetailsConvArchive() {
  return (
    <section className={styles.workspaces}>
      <AccessOverlay allowedTypes={ALLOWED_TYPES} />

      <div style={{ paddingBottom: '200px' }}>
        <UserDetailConvArchive />
      </div>
    </section>
  );
}

export default UserDetailsConvArchive;
